/**
 * HTML helpers: always escape untrusted text before injecting markup.
 */

const toSafeString = (value) => (
  typeof value === 'string' ? value : String(value ?? '')
);

export const escapeHtml = (value = '') => (
  toSafeString(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
);

/**
 * @param {unknown} value
 * @param {{ style?: 'markdown' | 'whatsapp'; preserveDoubleSpaces?: boolean }} [options]
 * - markdown: **bold**, *italic* (FormPrompt / support bot)
 * - whatsapp: * and ** both become <strong> (chat / campanhas)
 */
export const formatMarkdownToSafeHtml = (value, options = {}) => {
  const { style = 'markdown', preserveDoubleSpaces = false } = options;
  let safeText = escapeHtml(value);
  if (!safeText) return '';

  if (preserveDoubleSpaces) {
    safeText = safeText.replace(/ {2}/g, ' &nbsp;');
  }

  // Literal "\n" sequences sometimes stored in DB payloads
  safeText = safeText.replace(/\\n/g, '\n');

  if (style === 'whatsapp') {
    return safeText
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.+?)\*/g, '<strong>$1</strong>')
      .replace(/\n/g, '<br />');
  }

  return safeText
    .replace(/\*\*\*([^\n]+?)\*\*\*/g, '<strong>$1</strong>')
    .replace(/\*\*([^\n]+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*([^\n]+?)\*/g, '<em>$1</em>')
    .replace(/\n/g, '<br />');
};
